import type { IconSvgObject } from './types';

const Navigation04Icon: IconSvgObject = [
  ["path", { d: "M15.6539 8.09889L7.54093 10.4169C7.35996 10.4686 7.3441 10.7189 7.5171 10.793L11.3167 12.4212C11.4348 12.4718 11.5288 12.5658 11.5794 12.6838L13.2078 16.4829C13.2819 16.6559 13.5322 16.64 13.5839 16.4591L15.9011 8.34612C15.9442 8.19526 15.8047 8.05579 15.6539 8.09889Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export default Navigation04Icon;
